import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790106cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cards" }
const _hoisted_2 = { class: "cards-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagens, (imagem) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: imagem.address,
          imagem: imagem
        }, null, 8, ["imagem"]))
      }), 128))
    ])
  ]))
}